import { useRef, useEffect, ReactElement, Fragment, cloneElement } from 'react'

import ContainerHomGradientBorder from '~/components/Containers/ContainerHomGradientBorder'
import useDropdownMenu from '~/shared/hooks/useDropdownMenu.hook'
import { DropdownMenuStatus } from '~/shared/types/dropdownMenu.types'

import DropdownMenuHeader from './components/DropdownMenuHeader'

export default function DropdownMenu({
  children,
  header,
  selectedStateLabel,
  prefrencePage = false,
  error = '',
}: {
  children: ReactElement
  header: string
  selectedStateLabel?: string
  prefrencePage?: boolean
  error?: string | undefined
}): React.ReactElement {
  const sectionRef = useRef<HTMLDivElement>(null)
  const sectionContentRef = useRef<HTMLDivElement>(null)
  const { handleOnDropdownMenuToggle, status, openDropdownMenu } = useDropdownMenu(sectionRef, sectionContentRef)

  useEffect(() => {
    // Recalculate the height if a DOM node is added or removed.
    if (sectionRef.current && sectionContentRef.current) {
      const section = sectionRef.current
      const sectionContent = sectionContentRef.current

      if (status === DropdownMenuStatus.OPEN) {
        section.style.height = `${sectionContent.scrollHeight}px`
      }
    }
  }, [children, status])

  return (
    <ContainerHomGradientBorder error={error}>
      <DropdownMenuHeader dropdownIsOpen={status === DropdownMenuStatus.OPEN} onClick={handleOnDropdownMenuToggle}>
        {header}
        {selectedStateLabel && (
          <Fragment>
            : <span className="text-purple">{selectedStateLabel}</span>
          </Fragment>
        )}
      </DropdownMenuHeader>
      <section className="h-0 overflow-hidden transition-height duration-300" ref={sectionRef}>
        <div className="p-4 pt-0 opacity-0 transition" ref={sectionContentRef}>
          {prefrencePage
            ? cloneElement(children, {
                opendropdownmenufn: openDropdownMenu,
                parentstatus: status,
              })
            : children}
        </div>
      </section>
    </ContainerHomGradientBorder>
  )
}
